/**
 * InfyniteShores — Scroll Animations
 *
 * Fade-in strategy (zero flicker):
 *   1. html.js-ready is added by an inline <script> in <head> BEFORE any
 *      body content renders, so CSS opacity:0 applies on the very first paint.
 *   2. IntersectionObserver watches each element and adds .js-visible when
 *      it enters the viewport — CSS transition: opacity 2s handles the fade.
 *   3. GSAP is used only for the hero parallax (no opacity changes there).
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── DOM helper ──────────────────────────────────────────── */
  function $$(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  /* ══════════════════════════════════════════════════════════
     FADE-IN via IntersectionObserver + CSS class
     Elements are pre-hidden by CSS (opacity:0) so there is
     no frame where they flash from visible → invisible.
     IntersectionObserver adds .js-visible → CSS fades them in.
  ══════════════════════════════════════════════════════════ */
  function observeFade(elements, staggerMs) {
    if (!elements.length) return;

    /* Reduced-motion: reveal everything immediately, no transition */
    if (reducedMotion) {
      elements.forEach(function (el) { el.classList.add('js-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseFloat(el.dataset.fadeDelay || 0);
        setTimeout(function () {
          el.classList.add('js-visible');
        }, delay);
        observer.unobserve(el);
      });
    }, { threshold: 0.08 });

    elements.forEach(function (el, i) {
      if (staggerMs) {
        el.dataset.fadeDelay = i * staggerMs;
      }
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════════════════════════
     HERO PARALLAX — GSAP only (no opacity changes)
  ══════════════════════════════════════════════════════════ */
  function initParallax() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    gsap.config({ nullTargetWarn: false });

    $$('.banner__media').forEach(function (el) {
      var img = el.querySelector('img');
      if (!img) return;
      gsap.to(img, {
        yPercent: 12,
        ease: 'none',
        force3D: true,
        scrollTrigger: {
          trigger: el.closest('.banner, section') || el,
          start: 'top top',
          end: 'bottom top',
          scrub: 1.5
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════════════
     MAIN INIT
  ══════════════════════════════════════════════════════════ */
  function init() {
    /* ── Category cards (staggered: 200 ms between each) ── */
    $$('.collection-list').forEach(function (list) {
      observeFade($$('.collection-list__item', list), 200);
    });

    /* ── Product grid cards — collection, search, featured (150 ms) ── */
    $$('.product-grid, .collection, .search__results').forEach(function (grid) {
      observeFade($$('.card-wrapper', grid), 150);
    });
    /* Fallback: any remaining card-wrappers not already observed */
    $$('.card-wrapper:not([data-fade-delay]):not(.js-visible)').forEach(function (el) {
      observeFade([el]);
    });

    /* ── Multicolumn blocks (staggered: 180 ms) ── */
    $$('.multicolumn-list').forEach(function (list) {
      observeFade($$('.multicolumn-list__item', list), 180);
    });

    /* ── Image-with-text (media then content, 200 ms apart) ── */
    $$('.image-with-text').forEach(function (section) {
      var media   = section.querySelector('.image-with-text__media-item');
      var content = section.querySelector('.image-with-text__text-item');
      if (media)   observeFade([media]);
      if (content) {
        content.dataset.fadeDelay = 200;
        observeFade([content]);
      }
    });

    /* ── Rich text children ── */
    $$('.rich-text__blocks').forEach(function (el) {
      var kids = Array.from(el.children);
      observeFade(kids.length ? kids : [el], 120);
    });

    /* ── Testimonial slides ── */
    $$('.splide__list').forEach(function (list) {
      observeFade($$('.splide__slide', list), 180);
    });

    /* ── Footer columns ── */
    var footer = document.querySelector('.footer__content-top');
    if (footer) observeFade($$('.footer__col', footer), 150);

    /* ── FAQ accordion rows ── */
    var faqWrap = document.querySelector('.collapsible-content');
    if (faqWrap) observeFade($$('.accordion', faqWrap), 100);

    /* ── Section dividers ── */
    observeFade($$('.section-divider'));

    /* ── Blog articles ── */
    observeFade($$('.article-card'), 150);
    observeFade($$('.blog-articles .article'), 150);

    /* ── Hero parallax (GSAP, no opacity) ── */
    initParallax();

    /* Shopify Theme Editor: re-observe after section reload */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        init();
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
      });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

})();
